import React, { FC, useState } from "react"
import { Grid } from "@material-ui/core"

import BaseSnoozeDialog from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/components/BaseSnoozeDialog"

type SnoozeDialogProps = {
	inboxChannelChatId: number
	defaultOpen?: boolean
	onClose: () => void
	userId: number
	instanceId: number
}

const SnoozeDialog: FC<SnoozeDialogProps> = (props) => {
	const {
		defaultOpen = false,
		children,
		onClose,
		inboxChannelChatId,
		userId,
		instanceId
	} = props

	const [openSnoozeDialog, setOpenSnoozeDialog] = useState<boolean>(defaultOpen)

	const handleOpenSnoozeDialog = () => {
		setOpenSnoozeDialog(true)
	}

	const handleCloseSnoozeDialog = () => {
		setOpenSnoozeDialog(false)
		onClose()
	}

	const renderSimpleMessageDialog = () => {
		return (
			<BaseSnoozeDialog
				inboxChannelChatId={inboxChannelChatId}
				isOpenDialog={openSnoozeDialog}
				onClose={handleCloseSnoozeDialog}
				snoozeType="default"
				userId={userId}
				instanceId={instanceId}
			/>
		)
	}

	return (
		<Grid container style={{ width: "100%" }}>
			<Grid onClick={handleOpenSnoozeDialog} style={{ width: "100%" }}>
				{children}
			</Grid>
			{renderSimpleMessageDialog()}
		</Grid>
	)
}

export default SnoozeDialog
